import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import Trustpilot from '~components/Trustpilot/Trustpilot';
import ZipForm from '~components/ZipCodeForm/ZipCodeForm';
import BBBAccredited from '~images/inline/BBB.accredited.inline.svg';

interface IProps {
    includetrustpilotmobile?: boolean;
}

const SimplifiedMobile = ({ includetrustpilotmobile = false }: PropsWithChildren<IProps>) => {
    return (
        <section className="">
            <div
                className={classNames(
                    'rounded-lg flex justify-center md:pb-0',
                    includetrustpilotmobile ? 'py-6' : 'pt-6'
                )}
            >
                <div className="max-w-screen-xs md:max-w-screen-sm lg:max-w-screen-md w-full">
                    <ZipForm
                        buttonTitle="See plans"
                        buttonWaLink="Hero Zip Only: See plans"
                        qaValue="Hero:See plans"
                        opts={{
                            btnStyle: 'primary',
                            useWideLayout: true,
                            isHorizontalOnMobile: true,
                        }}
                        redirect={{
                            toUrl: process.env.GATSBY_EHMP_URL,
                            delay: 500,
                        }}
                    />
                </div>
            </div>
            {includetrustpilotmobile && (
                <>
                    <div className="flex justify-center">
                        <div className="pr-2">
                            <div
                                className="norton-placeholder w-20"
                                id="DigiCertClickID_onwANETs_17"
                            ></div>
                        </div>
                        <div className="pl-2">
                            <a
                                href="https://www.bbb.org/us/ca/santa-clara/profile/insurance-companies/ehealthinsurance-services-1216-359700#bbbseal"
                                target="_blank"
                                rel="noreferrer"
                                aria-label="BBB Accredited Business, BBB rating A plus"
                            >
                                <BBBAccredited width={85} height={30} alt="" loading="lazy" />
                            </a>
                        </div>
                    </div>
                    <div className="pt-5 flex justify-center">
                        <Trustpilot size="newthin" />
                    </div>
                </>
            )}
        </section>
    );
};

export default SimplifiedMobile;
